import React from 'react';
import { ReviewSummaryResponse } from '|/services/purchase-api/types';
import styles from './dmp-reminder.module.css';
import useOrderSummaryVm from '../../use-order-summary-vm';

interface DealerMarketPlaceReminderProps {
  summary: ReviewSummaryResponse | null;
  testId?: string;
}

const DealerMarketPlaceReminder: React.FC<DealerMarketPlaceReminderProps> = ({
  summary,
  testId = 'dealer-marketplace-reminder-section'
}) => {
  const { isMarketplaceVehicle } = useOrderSummaryVm(summary);

  if (!isMarketplaceVehicle) return null;

  return (
    <section className={styles.dmp} data-testid={testId}>
      <h3>This is a Carvana Marketplace vehicle</h3>

      <p>
        This vehicle comes with all the same great benefits as all our vehicles. This vehicle is in
        our partner's possession. Continue with your purchase as normal, and we will confirm this
        vehicle's availability for you once we've verified your order. If the vehicle becomes
        unavailable, we will let you know.
      </p>
    </section>
  );
};

export default DealerMarketPlaceReminder;
